export default "__VITE_ASSET__92e8b373__"